import { includes, isEmpty } from 'lodash';
import React from 'react';
import Slider from 'react-slick';
import { Link } from './styles/Link.styled';
import { SectionHeadline } from './styles/SectionHeadline.styled';
import { convertMonthToAr, dateToString } from '../helpers/date-convert';
import { Container } from './styles/Container.styled';
import { DWTCContext } from '../utils/context';

import {
  Wrapper,
  CardsContainer,
  Card,
  Date,
  ContentTitle,
  ContentDescription,
  CardWrapper,
  LatestNewsLink,
  LatestNewsMobileLink,
} from './styles/LatestNews.styled';
import Sprites from './Sprites';
import Articles from '../services/Articles';

export default function LatestNews({ data, dir, id }) {
  const { title, parentLink } = data;
  const { cssClass } = React.useContext(DWTCContext);
  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return 'red';
    if (includes(cssClass, 'real-estate')) return 'green';
    return 'secondary';
  };

  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: true,
    autoplay: false,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2,
          autoplay: false,
          dots: true,
        },
      },
      {
        breakpoint: 476,
        settings: {
          arrows: true,
          slidesToShow: 1,
          autoplay: false,
          dots: true,
        },
      },
    ],
  };

  const isArabic = dir === 'rtl';
  const articles = new Articles();
  const news = articles.get(isArabic ? 'ar' : 'en').slice(0, data.itemsLimit);

  const viewAll = isArabic ? 'عرض الكل' : 'VIEW ALL';

  return (
    <Wrapper dir={dir} id={id}>
      <Container>
        <SectionHeadline className="section_caption latest_news_caption" dir={dir}>
          <h2>{title}</h2>
          <Link
            color={getTheme()}
            to={isEmpty(parentLink) ? '#0' : parentLink.url}
            className="home_link latest_news_link"
          >
            {viewAll}
            <Sprites name="arrow" className="arrow" />
          </Link>
        </SectionHeadline>
        <CardsContainer dir={dir}>
          <Slider {...settings}>
            {isEmpty(news) ||
              news.map(({ date, title: descriptionTitle, description, url }, index) => (
                <CardWrapper className="card_latestnews" key={index}>
                  <Card to={url}>
                    <Date dir={dir}>
                      {isArabic ? convertMonthToAr(dateToString(date)) : dateToString(date)}
                    </Date>
                    <ContentTitle className="newstitle" dir={dir}>
                      {descriptionTitle}
                    </ContentTitle>
                    <ContentDescription dir={dir}>{description}</ContentDescription>
                  </Card>
                </CardWrapper>
              ))}
          </Slider>
        </CardsContainer>
        <LatestNewsMobileLink>
          <LatestNewsLink
            color={getTheme()}
            to={isEmpty(parentLink) ? '#0' : parentLink.url}
            dir={dir}
          >
            <p>{viewAll}</p>
            <Sprites name="arrow" className="arrow" />
          </LatestNewsLink>
        </LatestNewsMobileLink>
      </Container>
    </Wrapper>
  );
}
